module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@3.6.0@readable-stream/lib/internal/streams/stream-browser.js
// module id = 103
// module chunks = 8